import { Box } from '@mui/material';

// Banner: the image renders at the box's full width with its natural aspect
// ratio — full width preserved, the height adapts to the image, nothing
// cropped. Without an image the box falls back to a 16:9 placeholder area.
export default function BannerImage({ src, sx, children, ...rest }) {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        ...(src ? {} : { pt: `${(9 / 16) * 100}%` }),
        ...sx,
      }}
      {...rest}
    >
      {src ? (
        <Box
          component="img"
          src={src}
          alt=""
          sx={{ display: 'block', width: '100%', height: 'auto' }}
        />
      ) : (
        children
      )}
    </Box>
  );
}
